import { isFeatureEnabled } from 'owa-feature-flags';
import getRoamingTimezonesCloudSetting from '../selectors/getRoamingTimezonesCloudSetting';
import RoamingTimezone from '../store/schema/RoamingTimezone';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7034 (8,7): Variable 'DEFAULT_ROAMING_TIMEZONES_FALLBACK' implicitly has type 'any[]' in some locations where its type cannot be determined.
// @ts-expect-error
const DEFAULT_ROAMING_TIMEZONES_FALLBACK = [];

/**
 * Gets the default value for the roaming timezones setting
 */
export default function getDefaultRoamingTimezones(): RoamingTimezone[] {
    if (!isFeatureEnabled('mon-multipleTimezones')) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7005 (18,16): Variable 'DEFAULT_ROAMING_TIMEZONES_FALLBACK' implicitly has an 'any[]' type.
        // @ts-expect-error
        return DEFAULT_ROAMING_TIMEZONES_FALLBACK;
    }

    const roamingTimezones = getRoamingTimezonesCloudSetting();

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7005 (26,58): Variable 'DEFAULT_ROAMING_TIMEZONES_FALLBACK' implicitly has an 'any[]' type.
    // @ts-expect-error
    return roamingTimezones != null ? roamingTimezones : DEFAULT_ROAMING_TIMEZONES_FALLBACK;
}
